import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Dropdown from '@rd-web-markets/shared/dist/util/Dropdown';
import { DatePicker } from '@rd-web-markets/shared/dist/util/date';
import { TextFormFieldRow } from '@rd-web-markets/shared/dist/util/form/TextFormFieldRow';
import { IntegerFormFieldRow } from '@rd-web-markets/shared/dist/util/form/IntegerFormFieldRow';
import booleanSelectValue from '@rd-web-markets/shared/dist/helper_functions/booleanSelectValue';
const ContractorFurtherDetails = _ref => {
  var _contractor$funding_b;
  let {
    contractor,
    onChange,
    disabled = false
  } = _ref;
  const {
    t
  } = useTranslation();
  const booleanChange = e => {
    const raw = e.target.value;
    const value = raw === '' ? null : raw === 'true';
    onChange({
      target: {
        name: e.target.name,
        value
      }
    });
  };
  const dateChange = fieldName => date => {
    onChange({
      target: {
        name: fieldName,
        value: date
      }
    });
  };
  return /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Dropdown, {
    name: "further_funding_applied_or_granted_for_rd",
    label: "further_funding_applied_or_granted_for_rd",
    value: booleanSelectValue(contractor.further_funding_applied_or_granted_for_rd),
    onChange: booleanChange,
    options: [{
      key: 'further_funding_applied_or_granted_for_rd_yes',
      value: 'true',
      text: 'yes'
    }, {
      key: 'further_funding_applied_or_granted_for_rd_no',
      value: 'false',
      text: 'no'
    }],
    showNullOption: true,
    passEntireEvent: true,
    dataTestId: "further_funding_applied_or_granted_for_rd",
    disabled: disabled,
    dropdownStyle: {
      minWidth: '100%'
    }
  }), /*#__PURE__*/React.createElement(TextFormFieldRow, {
    fieldName: "funding_body",
    label: "funding_body",
    value: (_contractor$funding_b = contractor.funding_body) !== null && _contractor$funding_b !== void 0 ? _contractor$funding_b : '',
    onChange: onChange,
    disabled: disabled,
    dataTestId: "contractor_funding_body",
    formGroupClasses: contractor.further_funding_applied_or_granted_for_rd ? '' : 'd-none'
  }), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2 ".concat(contractor.further_funding_applied_or_granted_for_rd ? '' : 'd-none'),
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 3,
    htmlFor: "contractor_approval_date"
  }, t('approval_date')), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(DatePicker, {
    selected: contractor.approval_date,
    onChange: dateChange('approval_date'),
    disabled: disabled,
    "data-testid": "contractor_approval_date"
  }))), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2 ".concat(contractor.further_funding_applied_or_granted_for_rd ? '' : 'd-none'),
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 3,
    htmlFor: "contractor_alt_application_date"
  }, t('alt_application_date')), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(DatePicker, {
    selected: contractor.alt_application_date,
    onChange: dateChange('alt_application_date'),
    disabled: disabled,
    "data-testid": "contractor_alt_application_date"
  }))), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2 ContractorFurtherDetails-grant_amount ".concat(contractor.further_funding_applied_or_granted_for_rd ? '' : 'd-none'),
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 3,
    htmlFor: "integer_form_field_grant_amount"
  }, t('grant_amount')), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(IntegerFormFieldRow, {
    fieldName: "grant_amount",
    value: contractor.grant_amount,
    onChange: onChange,
    disabled: disabled,
    dataTestId: "contractor_grant_amount",
    formGroupClasses: contractor.further_funding_applied_or_granted_for_rd ? '' : 'd-none'
  }))));
};
export default ContractorFurtherDetails;